@media (prefers-color-scheme: light) {
  .tableWrapper {
    --table-shadow-overlay: rgb(250, 250, 250);
    --table-shadow-overlay-transparent: rgb(250, 250, 250, 0);
  }
}

@media (prefers-color-scheme: dark) {
  .tableWrapper {
    --table-shadow-overlay: rgb(31, 31, 31);
    --table-shadow-overlay-transparent: rgb(31, 31, 31, 0);
  }
}

.tableWrapper {
  max-width: 100%;
  overflow: auto hidden;
  position: relative;
  border-radius: 0.75rem;
  border: 1px solid var(--static-divider-standard);

  background:
    /* left shadow overlay */
    linear-gradient(90deg, var(--table-shadow-overlay) 30%, var(--table-shadow-overlay-transparent)) top left,
    /* right shadow overlay */
    linear-gradient(90deg, var(--table-shadow-overlay-transparent), var(--table-shadow-overlay) 70%) top right,
    /* left shadow  */
    linear-gradient(90deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0)) top left,
    /* right shadow  */
    linear-gradient(90deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.05)) top right;

  background-repeat: no-repeat;
  background-size: 2.5rem 100%, 2.5rem 100%, 0.5rem 100%, 0.5rem 100%;
  background-attachment: local, local, scroll, scroll;
}

.table {
  text-indent: 0;
  border-color: inherit;
  border-spacing: 0;
  table-layout: fixed;
  width: 100%;
}

.tableHead th,
.tableBody th,
.tableBody td {
  font-size: var(--fs-small);
  text-align: right;
  vertical-align: middle;
}

.tableHead th.sortable *,
.tableBody th.sortable * {
  cursor: pointer;
}

.stickyColumn {
  position: sticky;
  left: 0;
  z-index: 10;
  background-color: var(--table-shadow-overlay);
  text-align: left;
  white-space: nowrap;
}

.tableHead th {
  border-bottom: 1px solid var(--static-divider-standard);
  padding: 1rem;
  font-weight: 500;
}
.tableBody tr:last-child,
.tableBody tr:last-child th,
.tableBody tr:last-child td {
  border-bottom: none;
}

.tableBody th,
.tableBody td {
  padding: 0 1rem;
  border-bottom: 1px solid var(--static-divider-standard);
}

.tableCellSkeleton {
  float: right;
}


.tableContainer {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;
}

.tableHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  z-index: 11; /* needs to be a higher index than .stickyColumn */
}

.tableRowActionButton {
  border: transparent;
  background: transparent;
  cursor: pointer;
  padding: 0.5rem;
  margin-right: 0.25rem;
  color: var(--static-text-standard);
  border-radius: 0.5rem;
}

.tableRowActionButton:hover {
  background: rgba(0, 0, 0, 0.05);
}

.tableRowActionButton svg {
  fill: var(--static-text-standard);
}

.tableHeaderCellItem {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 0.25rem;
}

.firstTableHeaderCellItem {
  justify-content: start;
}

.tableHeaderCellTitle {
  white-space: nowrap;
}

.tableHeaderSortButton {
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--static-text-standard);
  min-height: 1.5rem !important;
  min-width: 1.5rem !important;
  padding: 0 !important;
  margin-left: 2px;
}

.tableHeaderControls {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
}

.bodyCellContainer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.bodyCellLeftAligned {
  justify-content: flex-start;
}

.noPadding {
  padding: 0 !important;
}